<div
  class="layout-container"
  [ngClass]="containerClass()"
>
  <pfx-app-topbar></pfx-app-topbar>

  @if (loadingStore.isLoading()) {
    <div class="loading-bar">
      <p-progressBar
        mode="indeterminate"
        [style]="{ height: '.25rem' }"
      />
    </div>
  }
  <app-sidebar></app-sidebar>

  <div class="layout-content-wrapper">
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>

    <!-- currently we don't need not footer -->
    <!--app-footer></app-footer-->
  </div>
  <app-config></app-config>

  @if (layoutService.state.staticMenuMobileActive) {
    <div class="layout-mask"></div>
  }
</div>
